<template>
  <div class="nav-menu" :class="theme">
    <button class="nav-menu-item" type="button" @click="openFDS">
      基本面数据
    </button>
    <button class="nav-menu-item" type="button" @click="openBusinessSchool">
      商学院
    </button>
  </div>
</template>

<script>
import { apiGetFDSToken } from "@/api/fds";
import { buildFDSLoginUrl, getFDSTokenFromResponse } from "@/utils/fds";

const BUSINESS_SCHOOL_URL = "https://xy.dpswang.com/";

export default {
  name: "NavMenu",
  props: {
    // light: 浅色导航栏；dark: 首页深色导航栏
    theme: {
      type: String,
      default: "light",
    },
  },
  methods: {
    async openFDS() {
      const fdsWindow = window.open("", "_blank");

      try {
        const response = await apiGetFDSToken();
        const token = getFDSTokenFromResponse(response);

        if (!token) {
          fdsWindow && fdsWindow.close();
          this.$message.error("获取基本面系统token失败");
          return;
        }

        const url = buildFDSLoginUrl(token);
        if (fdsWindow) {
          fdsWindow.location.href = url;
        } else {
          window.open(url, "_blank");
        }
      } catch (e) {
        fdsWindow && fdsWindow.close();
        this.$message.error("获取基本面系统token失败");
      }
    },
    openBusinessSchool() {
      window.open(BUSINESS_SCHOOL_URL, "_blank", "noopener,noreferrer");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-menu {
  display: flex;
  align-items: center;

  .nav-menu-item {
    padding: 0;
    border: 0;
    background: transparent;
    font-size: 16px;
    font-weight: 600;
    line-height: 60px;
    cursor: pointer;
    margin-left: 28px;
  }

  &.light .nav-menu-item {
    color: #666666;

    &:hover {
      color: #dd593b;
    }
  }

  &.dark .nav-menu-item {
    color: #ffffff;

    &:hover {
      color: #e25840dc;
    }
  }
}
</style>
